import axios from 'utils/requestHelper';

const fetchAll = (params) => axios.get('v1/clients/categories', { params });

const CategoryAPI = {
  fetchAll,
};

export default CategoryAPI;
